/**
 * Feature flags owned by the Private Hosting project.
 */
export const PRIVATE_HOSTING_FLAG_NAMES = {
  // Enable after every worker can read the optional inventory checkpoint.
  // Before reverting the reader, disable this flag and drain in-flight exports.
  PRIVATE_HOSTING_CODE_MODULES: 'ff-host-1258-private-hosting-code-modules',
  // Enable after the sandbox CLI supports --portable.
  PRIVATE_HOSTING_PORTABLE_CODE_BUNDLES:
    'ff-host-1264-private-hosting-portable-code-bundles',
  PRIVATE_HOSTING_INTERNAL: 'ff-host-586-private-hosting-internal',
  // Gates the customer-facing deploy surface only. Kept separate from
  // PRIVATE_HOSTING_INTERNAL so the pipeline and the Designer button roll out
  // independently; a customer deploy requires both.
  DEPLOY_BUTTON: 'ff-host-588-private-hosting-deploy',
  // Server-renders code islands on exported CMS pages through each module's
  // Cloudflare SSR worker. Needs PRIVATE_HOSTING_INTERNAL as well.
  PRIVATE_HOSTING_CODE_ISLAND_SSR:
    'ff-host-1270-private-hosting-code-island-ssr',
  // Plans secondary locales. Keep it off outside test sites: until the stages
  // after globals accept localized plan entries, those exports fail in pages.
  LOCALIZED_EXPORT: 'ff-host-1253-private-hosting-localized-export',
} as const;
